import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ReactiveFormsModule } from '@angular/forms';

import { AngularFireModule } from 'angularfire2';
import { AngularFireStorageModule } from 'angularfire2/storage';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { QuestionListModule } from './question-list/question-list.module';
import { AuthModule } from './auth/auth.module'
import { CoreModule } from './core/core.module';
import { reducers } from './store/app.reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';

import { AuthEffects } from './auth/store/auth.effects';
import { ReportComponent } from './report/report.component';
import { ReportEffects } from './report/store/report.effects';

import { NvD3Module } from 'ng2-nvd3';
import 'd3';
import 'nvd3';

import { ChartsModule } from 'ng2-charts';
import { BarChartComponent } from './report/charts/bar-chart/bar-chart.component';
import { DoughnutChartComponent } from './report/charts/doughnut-chart/doughnut-chart.component';
import { RadarChartComponent } from './report/charts/radar-chart/radar-chart.component';
import { LineChartComponent } from './report/charts/line-chart/line-chart.component';
import { PolarAreaChartComponent } from './report/charts/polar-area-chart/polar-area-chart.component';
import { PieChartComponent } from './report/charts/pie-chart/pie-chart.component';
import { BoxPlotChartComponent } from './report/charts/box-plot-chart/box-plot-chart.component';
import { EventFinderComponent } from './report/event-finder/event-finder.component';
import { LineChartWithTableComponent } from './report/charts/line-chart-with-table/line-chart-with-table.component';


@NgModule({
  declarations: [
    AppComponent,
    ReportComponent,
    BarChartComponent,
    DoughnutChartComponent,
    RadarChartComponent,
    LineChartComponent,
    PolarAreaChartComponent,
    PieChartComponent,
    BoxPlotChartComponent,
    EventFinderComponent,
    LineChartWithTableComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpModule,
    AppRoutingModule,
    SharedModule,
    QuestionListModule,
    AuthModule,
    CoreModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([AuthEffects, ReportEffects]),
    StoreRouterConnectingModule,
    NvD3Module,
    ChartsModule,
    !environment.production ? StoreDevtoolsModule.instrument() : []
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts